import { MOCK_CREWS } from "@/lib/mockData";
import CrewCard from "@/components/CrewCard";
import { Users } from "lucide-react";

const Crews = () => {
  return (
    <div className="pt-5" data-testid="crews-page">
      <h1 className="font-heading font-black text-3xl mb-1">Crews</h1>
      <p className="text-sm text-[#555555] mb-5">Groups that keep showing up together. One tap to invite the whole crew.</p>

      <div className="space-y-3">
        {MOCK_CREWS.map((c, i) => (
          <CrewCard key={c.id} crew={c} index={i} />
        ))}
      </div>

      <div className="brutal-card p-5 mt-6 bg-[#FFFBEB]">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 brutal-border bg-white rounded-lg flex items-center justify-center shrink-0">
            <Users className="w-5 h-5" />
          </div>
          <div>
            <div className="font-heading font-bold text-base mb-1">How crews & streaks work</div>
            <p className="text-sm text-[#555555]">
              After an activity wraps, the group is saved as a crew. Hit a <span className="font-bold text-[#0A0A0A]">3-streak</span> together and the host&apos;s linked venue drops a free deal token for the whole crew — your reason to keep showing up.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Crews;
